import { render, staticRenderFns } from "./AlertDecagram.vue?vue&type=template&id=137d8918&"
import script from "./AlertDecagram.vue?vue&type=script&lang=js&"
export * from "./AlertDecagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports